
export enum enumAudioLinkType {
  GoogleCloudStorage = 'GoogleCloudStorage', // audio stored within GoogleCloudStorage
  ExternalSource = 'ExternalSource', // an audio hosted at an external source (SoundCloud, etc.)
}
